import { useEffect } from "react";
import Hotspot from "./Hotspot";


const ClickableHotspot = ({ shapeProps, interaction }: BaseShapeProps<Hotspot>) => {
  useEffect(() => {
    const endClick = (e: MouseEvent) => {
      interaction?.handleClickEnd?.(shapeProps);
    }
    const moveHotpsot = (e: MouseEvent) => {
      interaction?.handleClickMove?.(e);
    }

    window.addEventListener("mousemove", moveHotpsot)
    window.addEventListener("click", endClick);
    return () => {
      window.removeEventListener("click", endClick);
      window.removeEventListener("mousemove", moveHotpsot);
    };
  }, [shapeProps, interaction])


  return (
    <Hotspot shapeProps={shapeProps} interaction={interaction} />
  )
}


export default ClickableHotspot;